<template>
    <v-container fluid class="login-container">
    <view-card-template>

        <template #viewHeader>
            <view-app-bar></view-app-bar>
        </template>
        <template #cardTitle>
            <span class="primaryLogo">CS</span><span class="secondaryLogo">Archive</span>
        </template>
        <template #cardBody>
            <v-row>
                <v-col sm="4" v-if="isDate === false">
                    <v-select label="Search Fields" class="mx-4" :items="dropDown"
                    v-model="currentSelection"
                        @input="updateBoolean(currentSelection)"></v-select>
                </v-col>
                <v-col sm="5" v-if="isDate === true">
                    <v-select label="Search Fields" class="mx-4" :items="dropDown"
                    v-model="currentSelection"
                        @input="updateBoolean(currentSelection)"></v-select>
                </v-col>
                <v-col sm="6" v-if="isDate === false">
                    <v-text-field class="mx-4" label="Search" hide-details v-model="inputValue" />
                </v-col>
                <v-col sm="3" v-if="isDate === true">
                    <v-menu v-model="menu2" :close-on-content-click="false"
                    :nudge-right="40" transition="scale-transition"
                        offset-y class="mx-4" min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="date" label="Start Date" readonly v-bind="attrs"
                                v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="date" @input="menu2 = false"></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col sm="3" v-if="isDate === true">
                    <v-menu v-model="menu3" :close-on-content-click="false"
                    :nudge-right="40" transition="scale-transition"
                        offset-y class="mx-4" min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="endDate" label="End Date"
                            readonly v-bind="attrs"
                                v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="endDate" @input="menu3 = false"></v-date-picker>
                    </v-menu>
                </v-col>
            </v-row>
            <v-row>
                <v-col sm="2">
                    <v-btn v-on:click="getData(currentSelection, inputValue)"
                    class="mr-4 my-4" color="blue"
                        elevation="2" width="60%">
                        Search
                    </v-btn>
                </v-col>
                <v-col sm="2">
                    <v-btn v-on:click="reset($event)" class="mr-4 my-4" color="blue"
                    elevation="2" width="60%">
                        Reset
                    </v-btn>
                </v-col>
                <v-col sm="8"></v-col>

            </v-row>
            <v-row class="mt-3 borderBottomThinSolidGray marginNone" >
              <v-col sm="3" v-if="(initialData.length > 0 || tableData.length > 0)
              && isDate === false">
                  <v-text-field class="mx-4" label="Filter" hide-details v-model="search">
                  </v-text-field>
              </v-col>
              <v-col sm="5" v-if="(initialData.length > 0 || tableData.length > 0)
              && isDate === true">
                  <v-text-field class="mx-4" label="Filter" hide-details v-model="search">
                  </v-text-field>
              </v-col>
              <v-col sm="4"></v-col>
            </v-row>
            
            <v-data-table :headers="dynamicHeaders" :items="tableData" :page="1" :pageStart="2"
            :pageStop="2"
                :items-per-page="5"
                :search="search" light calculate-widths show-select
                class="expanding-v-data-table elevation-1" width="100%" :footer-props="{
                    prevIcon: '<',
                    showCurrentPage: true,
                    nextIcon: '>'
                }" v-if="tableData.length > 0">
                <template v-slot:[`item.controls`]="props">
                    <v-container>
                        <v-avatar size="x-large" rounded="0" color="primary"
                        @click="onButtonClick(props.item)" class="v-slider__thumb">
                            <img src="../assets/pdf.png" alt="pdf">
                        </v-avatar>
                    </v-container>
                </template>
                <template v-slot:top="{ pagination, options, updateOptions }">
                    <v-data-footer prev-icon="<" :show-current-page="true"
                    next-icon=">" :pagination="pagination"
                        :options="options" @update:options="updateOptions"
                        items-per-page-text="$vuetify.dataTable.itemsPerPageText" />
                </template>
            </v-data-table>
            <v-data-table :headers="headersInitial" :items="initialData"
            :page="1" :pageStart="2" :pageStop="2"
                :items-per-page="5" :search="search" light calculate-widths show-select
                class="expanding-v-data-table elevation-1" width="100%" :footer-props="{
                    prevIcon: '<',
                    showCurrentPage: true,
                    nextIcon: '>'
                }"
                v-if="initialData.length > 0 && tableData.length === 0">
                <template v-slot:[`item.controls`]="props" v-if="item.manifest !== 'pending'">
                    <v-container class="v-slider__thumb">
                        <v-avatar size="x-large" @click="onButtonClick(props.item)" rounded="0" >
                            <img src="../assets/pdf.png" alt="pdf">
                        </v-avatar>
                    </v-container>
                </template>
                <template v-slot:top="{ pagination, options, updateOptions }">
                    <v-data-footer prev-icon="<" :show-current-page="true" next-icon=">"
                        :pagination="pagination"
                        :options="options" @update:options="updateOptions"
                        items-per-page-text="$vuetify.dataTable.itemsPerPageText" />
                </template>
            </v-data-table>
            <v-dialog v-model="dialog" width="auto" fullscreen :scrim="false"
            transition="dialog-bottom-transition">
                <v-card>
                    <pdf-view v-bind:str-manifest-name="manifestName"
                    v-bind:str-company-name="strCompanyName"
                    v-bind:result-company="resultCompany"
                    v-bind:str-submission="submission"
                        @clicked="dialog = false"></pdf-view>
                </v-card>
            </v-dialog>
            <v-dialog v-model="noResults" max-width="500px">
              <v-card>
                <v-card-title>
                  Invalid search
                </v-card-title>
                <v-card-text>
                  <p>'{{ currentSelection }}' returned no results for '{{ inputValue }}'</p>
                  <p>Please validate your criteria and try again.</p>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="noResults = false">Close</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
        </template>
    </view-card-template>
    <view-footer></view-footer>
</v-container>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { Auth } from 'aws-amplify';
import { mapState, mapGetters } from 'vuex';
import ViewCardTemplate from '../components/templates/ViewCardTemplate.vue';
import ViewAppBar from '../components/templates/ViewAppBar.vue';
import PdfView from '../components/templates/PdfViewArchive.vue';
import ViewFooter from '../components/templates/ViewFooter.vue';

export default {
  name: 'table-view',
  components: {
    ViewCardTemplate,
    ViewAppBar,
    PdfView,
    ViewFooter
  },
  data: () => ({
    headers: [
      {
        text: 'Recipient Name',
        align: 'start',
        sortable: true,
        value: 'name',
      },
      { text: 'Policy Number', value: 'policyNumber' },
      { text: 'Address', value: 'address' },
      { text: 'Job ID', value: 'jobId' },
      { text: 'Filename', value: 'originalFilename' },
      { text: 'Check Number', value: 'checkNumber' },
      { text: 'Check Amount', value: 'checkAmount' },
      { text: 'Received Date', value: 'receivedDate' },
      { text: 'Company', value: 'company'},
      { text: 'PDF', value: 'controls', sortable: false }
    ],
    headersInitial: [
      {
        text: 'Job ID',
        align: 'start',
        sortable: true,
        value: 'jobId',
      },
      { text: 'File Name', value: 'fileName' },
      { text: 'Submission', value: 'submission' },
      { text: 'Received Date', value: 'receivedDate' },
    ],
    inputValue: null,
    item: 'test',
    tableData: [],
    initialData: [],
    dropDown: ['Filename', 'Recipient Name', 'Policy Number', 'Check Number'],
    currentSelection: 'Filename',
    initialLoad: '',
    date: new Date().toISOString().substr(0, 10),
    endDate: new Date().toISOString().substr(0, 10),
    menu: false,
    modal: false,
    menu2: false,
    menu3: false,
    isDate: false,
    search: '',
    dialog: false,
    manifestName: '',
    strCompanyName: '',
    resultCompany: '',
    noResults: false,
    submission: '',
  }),
  computed: {
    ...mapState(['user']),
    ...mapGetters(['getUser']),
    user() {
      return this.getUser;
    },
    dynamicHeaders() {
      // Clone the original headers array
      let clonedHeaders = JSON.parse(JSON.stringify(this.headers));

      // Check if checkNumber and checkAmount are empty
      if (!this.tableData[0].checkNumber && !this.tableData[0].checkAmount) {
        // If both checkNumber and checkAmount are empty, remove the columns from the clonedHeaders
        clonedHeaders = clonedHeaders.filter(header => header.value !== 'checkNumber' && header.value !== 'checkAmount');
      }
      if(!this.tableData[0].company) clonedHeaders = clonedHeaders.filter(header => header.value !== 'company')
      return clonedHeaders;
    }
  },
  
  async mounted() {
     await this.getAttributes()
     this.getInitialData('In Progress')
     if (this.strCompanyName === 'Northern Neck') {
      // Remove 'Check Number' from the dropdown
      this.dropDown = this.dropDown.filter(option => option !== 'Check Number');
    }
  },
  methods: {
    async getAttributes() {
      let user = await Auth.currentAuthenticatedUser();
      this.strCompanyName = user.attributes['custom:companyName'];
      console.log(typeof user.attributes['custom:acceptedTerms']);
    },
    async getData(searchType, searchValue) {
      this.initialData = [];
      this.tableData = [];
      const inputText = searchValue;
      let data;
      switch (searchType) {
        case 'Policy Number':
          data = JSON.stringify({
            policyNumber: inputText,
            companyName: this.strCompanyName,
          });
          break;
        case 'Check Number':

          data = JSON.stringify({ companyName: this.strCompanyName, checkNumber: inputText });
          break;
        case 'Recipient Name':
          data = JSON.stringify({ companyName: this.strCompanyName, recipientName: inputText });
          break;
        case 'Filename':
          data = JSON.stringify({ companyName: this.strCompanyName, fileName: inputText });
          break;
        case 'recordsByFilename':
          data = JSON.stringify({ companyName: this.strCompanyName, recordsByFilename: inputText });
          break;
        case 'Received Date':

          data = JSON.stringify({
            companyName: this.strCompanyName,
            startDate: this.date,
            endDate: this.endDate,
          });
          break;
        default:
      }
      const config = {
        method: 'post',
        url: process.env.VUE_APP_API_ARCHIVE_URL,
        headers: {
          'x-api-key': process.env.VUE_APP_API_ARCHIVE_KEY,
          'Content-Type': 'application/json',
        },
        data,
      };
      const response = await axios(config);
      // eslint-disable-next-line
        for (const obj of response.data) {
        obj.address = obj.address.replace(',,,', '').replace(',,', '');
      }
      const arrObjects = response.data;
      if(arrObjects.length === 0) this.noResults = true 
      else {
        if (searchType === 'Job Status') this.initialData = arrObjects;
        else this.tableData = arrObjects;
        this.initialLoad = false;
      }
    },
    async getInitialData() {
      const data = JSON.stringify(
        {
          companyName: this.strCompanyName,
          initial: true,
        },
      );

      const config = {
        method: 'post',
        url: process.env.VUE_APP_API_ARCHIVE_URL,
        headers: {
          'x-api-key': process.env.VUE_APP_API_ARCHIVE_KEY,
          'Content-Type': 'application/json',
        },
        data,
      };
      try{
        const response = await axios(config);
        const arrObjects = response.data.map(resData => {
          resData.receivedDate = moment(resData.receivedDate, 'YYYY-M-D').format('YYYY-MM-DD');
          return resData;
        });
        this.initialData = arrObjects;
      } catch(e) {
        console.log(e)
      }
    },

    updateBoolean(event) {
      if (event === 'Received Date') this.isDate = true;
      else this.isDate = false;
    },
    reset() {
      this.tableData = [];
      this.initialData = [];
      this.inputValue = '';
      this.search = '';
      this.getInitialData();
      this.dialog = false;
      this.date = null;
      this.endDate = null;
    },
    onButtonClick(item) {
      const company = item.company;
      this.resultCompany = item.company
      this.manifestName = item.originalFilename;
      this.submission = item.submission;
      this.companyName = company;
      this.dialog = true;
    },
  },
  created() {
    // const groups = this.user.signInUserSession.accessToken.payload['cognito:groups'] || [];
    // // eslint-disable-next-line
    // this.strCompanyName = groups[0];
    // this.getInitialData();
  },
};
</script>

<style lang="scss" scoped>
.image-fit{
  height: 100%;
  width: 100%;
  object-fit: cover;
}
.primaryLogo{
    font-style: italic;
    color: black;
    font-weight: 800;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 24pt;
}
.secondaryLogo{
    font-style: italic;
    color: blue;
    font-weight: 1000;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 24pt;
}
.my-pagination {
    .v-data-footer .v-icon {
        & .v-pagination__navigation {
            background: blue !important;
        }

        /*For page buttons except the active one*/
        & .v-pagination__item:not(.v-pagination__item--active) {
            background: yellow !important;
        }
    }
}
.login-container {
   background-image: url("~@/assets/background.png"); /* Replace with the path to your PNG image */
   background-size: cover;
   background-position: center;
   min-height: 100vh;
 }
 .v-slider__thumb{
  cursor:pointer;
}

.borderBottomThinSolidGray {
  border-top: thin solid rgba(0, 0, 0, 0.12);
}

.theme--light.v-data-table .v-data-footer {
  border-top: none !important;
}

.v-application .elevation-1 {
  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0) !important;
}

.marginNone {
  margin: 0%;
}
</style>
